/** @file The replayed view of each DocSlice object (currentDoc reads it, dispatch primes it). */
import type { Doc } from '@pose2d/format/types';
import type { DocSlice } from './types';

/** DocSlice → the document panels show for it; entries die with their slice. */
export const viewCache = new WeakMap<DocSlice, Doc>();
